import { TriangleAlert } from 'lucide-react'
import { Button } from '@/components/ui/button'
import { Card } from '@/components/ui/card'
import type { FallbackProps } from 'react-error-boundary'

export const GenericErrorFallback = ({
  error,
  resetErrorBoundary,
}: FallbackProps) => {
  return (
    <Card>
      <div className="flex flex-col items-center justify-center py-24">
        <div className="mx-auto size-24 rounded-full bg-linear-to-b from-destructive/10 to-transparent flex items-center justify-center">
          <div className="size-14 bg-background flex items-center justify-center rounded-full border border-destructive/10 shadow-xs shadow-destructive/5">
            <TriangleAlert className="size-6 text-destructive" />
          </div>
        </div>
        <h1 className="my-4 text-2xl font-display text-center">
          Something went wrong
        </h1>
        <div className="flex flex-col gap-4 items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold"></h1>
            <p className="text-muted-foreground">Error message:</p>
            <pre className="mt-2 bg-accent p-4 rounded-lg whitespace-pre-line">
              {error.message}
            </pre>
          </div>
          <Button variant="destructive" onClick={resetErrorBoundary}>
            Reset application
          </Button>
        </div>
      </div>
    </Card>
  )
}
